import Component from './SelectAllColumnsCheckbox.component';

export default Component;
